import {
    GET_DRIVER_TITLE,
    SET_DRIVER_TITLE,
} from "./DriverTitleType"

const getDriverTitle = (isJobTitle: any) => ({
    type: GET_DRIVER_TITLE,
    isJobTitle
});

const setDriverDetail = (driverTitleList: any) => ({
    type: SET_DRIVER_TITLE,
    driverTitleList,
});

export {
    getDriverTitle,
    setDriverDetail
}
